import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash' 
import axios from 'axios'
import moment from 'moment'

import artists from './artists'
import site from './site'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    site, artists
  },
  state: {
    menuOpen: false,
    overlayOpen: false,
    scrollDirection: null,
    scrollTop: 0,
    artists: null,
    windowHeight: window.innerHeight
  },
  actions: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    scrollTop({state, commit}, scrollTop) {
      if(scrollTop > 0 && scrollTop > state.scrollTop) {
        commit('scrollDirection', 'down')
      } else {
        commit('scrollDirection', 'up')
      }
      commit('scrollTop', scrollTop)
    }
  },
  mutations: {
    scrollTop(state, scrollTop) {
      state.scrollTop = scrollTop
    },
    scrollDirection(state, scrollDirection) {
      state.scrollDirection = scrollDirection
    },
    openMenu(state) {
      state.menuOpen = true
    },
    closeMenu(state) {
      state.menuOpen = false
    },
    windowHeight(state, windowHeight) {
      state.windowHeight = windowHeight
    },
    overlayOpen(state, overlayOpen) {
      state.overlayOpen = overlayOpen
    }
  },
  getters: {
    scrolled(state) {
      return state.scrollTop > state.windowHeight
    },
    lockScroll(state) {
      return state.menuOpen || state.overlayOpen
    }
  }
})

store.dispatch('site/fetch')
store.dispatch('site/fetchInstagram')
store.dispatch('site/fetchCities')
store.dispatch('artists/fetch')

export default store


// WEBPACK FOOTER //
// ./src/store/store.js